import { Skeleton } from 'antd';
import { Card } from './Card';
import { AreaChart } from './AreaChart';

interface StatCardProps {
	icon: React.ReactNode;
	title: string | React.ReactNode;
	value: string | number;
	color: string;
	data: number[];
	category: string[];
	isLoading: boolean;
}

const StatCard = ({
	icon,
	title,
	value,
	color,
	data,
	category,
	isLoading = false,
}: StatCardProps) => (
	<Card className="hover:shadow border border-gray-200 overflow-hidden relative">
		<div className="absolute w-24 h-24 bg-blue-50 rounded-full -right-8 -top-8 opacity-50" />
		<div className="p-4">
			<div className="flex justify-between items-center mb-4 relative z-10">
				<div className="flex items-center justify-center w-12 h-12 rounded-xl text-xl bg-blue-50 text-blue-600">
					{icon}
				</div>
			</div>
			<div className="text-3xl font-bold mb-1 relative z-10">
				{isLoading ? <Skeleton.Avatar active /> : value}
			</div>
			<div className="text-gray-500 text-sm font-medium relative z-10">{title}</div>

			<div className="my-4">
				{isLoading ? (
					<Skeleton.Input block style={{ height: 75 }} active />
				) : (
					<AreaChart data={data} categories={category} color={color} />
				)}
			</div>
		</div>
	</Card>
);

export { StatCard };
